import { render } from "./AppSidebar.vue?vue&type=template&id=42cddce0&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=42cddce0&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cddce0"]])

export default __exports__